SA.CrosstabIndexTooltip = class {
    static create({state, target}) {
        var tooltip = new SA.Tooltip({
            target,

            content: [
                '<div class="sa-crosstab-tooltip-title">Index</div>',
                `<div class="sa-crosstab-tooltip-definition">The index measures the likelihood that respondents meet the criteria for the column and the row compared to the ${getPopulation(state.location)}. Indexes always have an average value of 100.</div>`,
                '<div>People in this group:</div>',
                `<div>${Ext.String.htmlEncode(SA.data.AttributesCache.get(state.ids.top).name)}</div>`,
                `<div>are <span class="sa-crosstab-tooltip-percent">${getLikelihood(state.data.index)}</span> to be in this group:</div>`,
                `<div>${Ext.String.htmlEncode(SA.data.AttributesCache.get(state.ids.left).name)}</div>`,
                `<div>than the ${getPopulation(state.location)} overall.</div>`
            ].join('')
        });

        tooltip.el.classList.add('sa-crosstab-tooltip');

        return tooltip;

        function getLikelihood(index) {
            index = Math.round(index);

            if (index > 100) {
                return `${index - 100}% more likely`;
            }
            else if (index < 100) {
                return `${100 - index}% less likely`;
            }
            else {
                return 'equally likely';
            }
        }

        function getPopulation(location) {
            if (location === 'usa:840') {
                return 'U.S. adult population';
            }
            else {
                return `adult population of ${Ext.String.htmlEncode(SA.data.LocationsCache.get(location).name)}`;
            }
        }
    }
};